import {Pipe, PipeTransform} from '@angular/core';
import {UtilitiesService} from "../../core/_services/utilities.service";

@Pipe({
    name: 'vehicleDisplay',
    pure: false
})
export class VehicleDisplayPipe implements PipeTransform {

    // any => Vehicle | Job | JobRequest
    transform(vehicle: any, includeLabel = false): string {
        if (UtilitiesService.isNotEmpty(vehicle)) {
            // type => ?
            if (vehicle.make === '0' && vehicle.model === '0') {
                return '+ Add Vehicle';
            }
            // type => Vehicle
            else if (vehicle.make && vehicle.model) {
                return toString(vehicle.year, vehicle.make, vehicle.model, vehicle.trim, vehicle.license, includeLabel ? vehicle.label : '');

            // type => Job | JobRequest
            } else if (vehicle.vehicleMake && vehicle.vehicleModel) {
                return toString(vehicle.vehicleYear, vehicle.vehicleMake, vehicle.vehicleModel, vehicle.vehicleTrim,
                    vehicle.vehicleLicense, includeLabel ? vehicle.vehicleLabel : '');
            }
        }

        return '';
    } // transform()

} // VehicleDisplayPipe

function toString(year: number, make: string, model: string, trim: string, license: string, label: string): string {
    return (UtilitiesService.isNotEmpty(label) ? `${label} - ` : '')
         + (`${year} ${make} ${model}`)
         + (UtilitiesService.isNotEmpty(trim) ? ` ${trim}` : '')
         + (UtilitiesService.isNotEmpty(license) ? ` - ${license}` : '');
} // toString()
